import merge from 'deepmerge'
import PropTypes from 'prop-types'
import React from 'react'

const shapeStyle = {
  fill: 'none',
  stroke: '#8e8e90',
  strokeLinecap: 'round',
  strokeWidth: 1
}

const baseStyles = {
  circle: { ...shapeStyle },
  path: { ...shapeStyle },
  line: { ...shapeStyle }
}

const Language = ({ styles = {}, ...props }) => {
  const merged = merge(baseStyles, styles)
  return (
    <svg width='20px' height='20px' viewBox='0 0 20 20' version='1.1' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle style={merged.circle} cx='10' cy='10' r='9' />

      <path style={merged.path} d='M4 4 C 6 6, 14 6, 16 4' />

      <path style={merged.path} d='M10 1 C 4 6, 4 14, 10 19' />

      <line
        style={merged.line}
        x1='10' y1='1'
        x2='10' y2='19'
      />
      <line
        style={merged.line}
        x1='1' y1='10'
        x2='19' y2='10'
      />

      <path style={merged.path} d='M10 1 C 16 6, 16 14, 10 19' />

      <path style={merged.path} d='M4 16 C 6 14, 14 14, 16 16' />
    </svg>
  )
}

Language.propTypes = {
  styles: PropTypes.shape({
    circle: PropTypes.object,
    path: PropTypes.object,
    line: PropTypes.object
  })
}

export default Language
